import { useFormContext, useWatch } from '@portals-platform/ui-forms';
import { isCustomerInformationComplete } from '../predicates.js';
import type { FormValues } from '../types.js';

export function useTemplateSectionState(): {
  isCustomerInfoComplete: boolean;
  templateId: string;
} {
  const { control } = useFormContext<FormValues>();
  const [certificateIssuedTo, customerAddress, countryCode, policyYear, templateId] = useWatch({
    control,
    name: [
      'certificateIssuedTo',
      'customerAddress',
      'countryCode',
      'policyYear',
      'certificateTemplateId',
    ],
  });

  return {
    isCustomerInfoComplete: isCustomerInformationComplete({
      certificateIssuedTo,
      customerAddress,
      countryCode,
      policyYear,
    }),
    templateId,
  };
}
